import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../hooks/useTheme";
import { useScrollEffects } from "../hooks/useScrollEffects";
import isologo from "../images/logo/isologo_neurocentro.png";
import neurocentroText from "../images/logo/neurocentro-text.png";
import { agendarUrl } from "../constants";
import { InstagramIcon, ChevronDownIcon, SunIcon, MoonIcon } from "../icons";

// Header layout
const menuItems = [
  {
    id: "inicio",
    label: "Inicio",
    type: "link",
    link: "/",
  },
  {
    id: "consultas",
    label: "Consultas Médicas",
    type: "link",
    link: "/consultas",
  },
  {
    id: "servicios",
    label: "Servicios",
    type: "link",
    link: "/servicios",
    // type: "submenu",
    // items: [
    //   { label: "Hospitalización", link: "/servicios/hospitalizacion" },
    //   { label: "Urgencias", link: "/servicios/urgencias" },
    //   { label: "Cirugías", link: "/servicios/cirugias" },
    //   { label: "Imagenología", link: "/servicios/radiografia" },
    //   { label: "Laboratorio Clínico", link: "/servicios/laboratorio" },
    //   { label: "Electrodiagnóstico", link: "/servicios/electrodiagnostico" },
    // ],
  },
  {
    id: "quienes-somos",
    label: "Quienes Somos",
    type: "link",
    link: "/neurocentro",
  },
  // {
  //   id: "careers",
  //   label: "Trabaja con Nosotros",
  //   type: "link",
  //   link: "/careers",
  // },
  {
    id: "contacto",
    label: "Contacto",
    type: "link",
    link: "/#contacto",
  },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const { toggleTheme } = useTheme();
  const { isSticky } = useScrollEffects();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    document.body.classList.toggle("overflow-hidden");
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    document.body.classList.remove("overflow-hidden");
  };

  const toggleSubmenu = (submenuId) => {
    setActiveSubmenu(activeSubmenu === submenuId ? null : submenuId);
  };

  return (
    <header
      className={`absolute top-0 left-0 z-50 w-full duration-300 navbar border-stroke dark:border-stroke-dark ${
        isSticky ? "sticky-navbar bg-white dark:bg-black" : "bg-transparent"
      }`}
    >
      <div className="container relative max-w-[1400px]">
        <div className="flex items-center justify-between">
          <div className="block py-4 lg:py-0">
            <Link to="/" className="block">
              <div className="flex items-center gap-2">
                <img
                  src={isologo}
                  alt="Neurocentro Veterinario"
                  className="h-[35px] sm:h-[44px] w-auto"
                />
                <div className="relative h-[40px] sm:h-[50px]">
                  <img
                    src={neurocentroText}
                    alt="Neurocentro Veterinario"
                    className="h-full w-auto"
                  />
                  <img
                    src={neurocentroText}
                    alt=""
                    aria-hidden="true"
                    className="absolute inset-0 h-full w-auto invert opacity-0 dark:opacity-100"
                    style={{ clipPath: "inset(0 0 65% 0)" }}
                  />
                </div>
              </div>
            </Link>
          </div>

          <button
            onClick={toggleMobileMenu}
            className="navbarOpen absolute right-4 top-1/2 z-50 flex h-10 w-10 -translate-y-1/2 flex-col items-center justify-center space-y-[6px] font-bold lg:hidden"
            aria-label="navbarOpen"
          >
            <span className="block h-[2px] w-7 bg-black dark:bg-white"></span>
            <span className="block h-[2px] w-7 bg-black dark:bg-white"></span>
            <span className="block h-[2px] w-7 bg-black dark:bg-white"></span>
          </button>

          <div
            className={`relative justify-between menu-wrapper lg:flex ${
              mobileMenuOpen ? "" : "hidden"
            }`}
          >
            <button
              onClick={closeMobileMenu}
              className="fixed flex flex-col items-center justify-center w-10 h-10 font-bold navbarClose top-10 right-10 z-9999 lg:hidden"
              aria-label="navbarClose"
            >
              <span className="block h-[2px] w-7 rotate-45 bg-black dark:bg-white"></span>
              <span className="-mt-[2px] block h-[2px] w-7 -rotate-45 bg-black dark:bg-white"></span>
            </button>

            <nav className="fixed top-0 left-0 flex items-center justify-center w-full h-screen text-center z-999 bg-white/95 backdrop-blur-xs dark:bg-black/95 lg:static lg:h-auto lg:w-max lg:bg-transparent lg:backdrop-blur-none lg:dark:bg-transparent">
              <ul className="items-center space-y-3 lg:flex lg:space-x-8 lg:space-y-0 xl:space-x-10">
                {menuItems.map((menuItem) => (
                  <li
                    key={menuItem.id}
                    className={`menu-item ${
                      menuItem.type === "submenu"
                        ? "relative submenu-item group"
                        : ""
                    }`}
                  >
                    {menuItem.type === "submenu" ? (
                      <>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleSubmenu(menuItem.id);
                          }}
                          className="inline-flex items-center text-base font-medium text-black submenu-taggler hover:text-primary group-hover:text-primary dark:text-white dark:hover:text-primary lg:py-7"
                        >
                          {menuItem.label}
                          <span className="pl-3">
                            <ChevronDownIcon className="fill-current" />
                          </span>
                        </a>
                        <ul
                          className={`submenu space-y-5 pt-5 duration-300 lg:invisible lg:absolute lg:top-[120%] lg:block lg:w-[250px] lg:rounded-lg lg:bg-white lg:px-8 lg:pb-5 lg:text-left lg:opacity-0 lg:shadow-card lg:group-hover:visible lg:group-hover:top-full lg:group-hover:opacity-100 dark:lg:border-transparent dark:lg:bg-[#15182A] lg:dark:shadow-card-dark ${
                            activeSubmenu === menuItem.id ? "" : "hidden"
                          }`}
                        >
                          {menuItem.items.map((subItem, index) => (
                            <li key={index}>
                              <Link
                                to={subItem.link}
                                onClick={closeMobileMenu}
                                className="inline-flex items-center justify-center text-base text-center text-black font-heading hover:text-primary dark:text-white dark:hover:text-primary"
                              >
                                {subItem.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <Link
                        to={menuItem.link}
                        onClick={closeMobileMenu}
                        className="inline-flex items-center text-base font-medium text-black hover:text-primary dark:text-white dark:hover:text-primary lg:py-7"
                      >
                        {menuItem.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          </div>
          <div className="mr-[60px] flex items-center justify-end lg:mr-0">
            <a
              className="mr-4 text-black dark:text-white"
              href="https://www.instagram.com/neurocentrovet/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon className="w-6 h-6" />
            </a>
            <Link
              to={agendarUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMobileMenu}
              className="hidden px-8 py-3 text-base font-medium text-white duration-300 rounded-md loginBtn bg-primary hover:bg-primary/90 lg:block"
            >
              Agendar Consulta
            </Link>
            <button
              id="themeSwitcher"
              onClick={toggleTheme}
              className="text-black dark:text-white ml-4"
              aria-label="theme switcher"
            >
              <SunIcon className="block dark:hidden" />
              <MoonIcon className="hidden dark:block" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
